import {mediaQueryStyles as mq, constants} from '@newsela/angelou';
import {css} from 'emotion';
const {
  colors: {ui},
} = constants;

export const breakpointSwitch = mq.mediaQuery.downTo(
  constants.breakpoints.BreakpointNames.sm
);

const pageNavWidth = '300px';
const white = ui.white['700'];

export const generatePageNavStyle = (bottomOffset) =>
  css({
    position: 'fixed',
    bottom: `${bottomOffset}px`,
    width: '100%',
    backgroundColor: white,
    [breakpointSwitch]: {
      width: pageNavWidth,
      position: 'fixed',
      height: '100%',
      bottom: 'auto',
    },
  });

export const generateContentStyle = (bottomOffset) =>
  css({
    marginBottom: `${bottomOffset}px`,
    width: '100%',
    [breakpointSwitch]: {
      marginBottom: 0,
      marginLeft: pageNavWidth,
    },
  });

export const mastHeadPositionStyle = css({
  '&&': {
    position: 'static',
    marginBottom: 0,
  },
});

export const headerStyle = css({
  width: '100%',
  position: 'relative',
  top: 0,
  backgroundColor: white,
  zIndex: 2,
  marginBottom: 0,
  borderBottom: `1px solid ${ui.greyLight['100']}`,
});

export const pinnedHeaderStyle = css({
  width: '100%',
  position: 'absolute',
  [breakpointSwitch]: {
    position: 'relative',
  },
  top: 0,
  backgroundColor: white,
  zIndex: 1,
  marginBottom: 0,
  borderBottom: `1px solid ${ui.greyLight['100']}`,
});
